import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

import StepGeneralFormContainer from '../../../../containers/projects/ChangeStrategyFormContainers/StepGeneralFormContainer.jsx';

const EditChangeStrategyStepGeneral = ({ projectId, slug }) => (
  <>
    <Helmet>
      <title>Edit Change Strategy | ChangeSync</title>
    </Helmet>
    <StepGeneralFormContainer projectId={projectId} slug={slug} />
  </>
);

EditChangeStrategyStepGeneral.getInitialProps = ({ query }) => ({
  slug: query.slug,
  projectId: Number(query.projectId),
});

export default requireAuth(withRouterParams(EditChangeStrategyStepGeneral));
